import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AppBreadcrumbService } from 'src/app/app.breadcrumb.service';
import { Empresa } from 'src/app/models/configuracion/empresa.model';
import { Contacto } from 'src/app/models/notificacion/contacto.model';
import { Ventana } from 'src/app/pages/base/ventana';
import { EmpresaService } from 'src/app/services/configuracion/empresa.service';
import { ContactoService } from 'src/app/services/notificacion/contacto.service';
import { ReporteService } from 'src/app/services/reporte.service';
import { normalizeParaguayPhone } from 'src/app/utilities/phone-normalizer';
import { Global } from 'src/global';

@Component({
  selector: 'app-contacto-ventana',
  templateUrl: './contacto-ventana.component.html',
  styleUrls: ['./contacto-ventana.component.scss']
})
export class ContactoVentanaComponent extends Ventana implements OnInit {

    constructor(
        public router: Router,
        public messageService: MessageService,
        public activateRoute: ActivatedRoute,
        public service: ContactoService,
        private breadcrumbService: AppBreadcrumbService,
        private empresaService: EmpresaService
    ) {
        super(router, activateRoute, messageService, service );
        const modelo = Contacto;
        this.modulo = modelo.CODIGO_MODULO;
        this.breadcrumbService.setItems([{ label: 'Notificacion' },{ label: 'Contactos' , routerLink: `${this.modulo}/contactos` },{ label: 'Nuevo' }]);
        this.codigoRegistro = modelo.CODIGO_REGISTRO;
        this.objClass = modelo;
        this.navigate = [this.prefixPage, this.modulo, 'contactos'];
        this.initComponent();
    }

    async ngOnInit(): Promise<void> {
        await this.applyPrefillFromQueryParams();
    }

    async onEmpresa() {
        try {
            const value = this.formGroup.value;  
            let objeto = null;
            const filtros = [
                { field: 'id', value: value.id_empresa, type: 'id' },
                
            ]
            const res = await this.empresaService.getAll( Global.SIZE_GET_ALL, { filters: filtros } );
            if ( res.ok && res.resp.count > 0 ) {
                objeto = res.resp.rows[0];
            } else {
                this.messageService.add({severity: 'info', summary: 'Empresa no encontrada', detail: ''});
            }
            await this.setEmpresa(objeto);
        } catch (error: any) {
            this.messageService.add(this.objSession);
            setTimeout( () => { this.router.navigate(this.routerLogout) }, 4000);
        }
    }

    async setEmpresa( obj: Record<string, any> ) {
        this.formGroup.get('id_empresa').setValue(obj?.id);
        // this.formGroup.get('ruc_empresa').setValue(obj?.ruc);
        this.formGroup.get('nombre_empresa').setValue(obj?.nombre);
    }

    async cerrarOnLista( obj?: Record<string, any> ): Promise<void> {
        await super.cerrarOnLista( obj );
        if ( this.objClass === Empresa && obj ) {
            await this.setEmpresa(obj);
        }
        this.objClass = null;
    }

    
    async onListaEmpresa() {
        await super.onLista( this.empresaService, Empresa, Empresa.NOMBRE_PLURAL );
    }

    private async applyPrefillFromQueryParams(): Promise<void> {
        const id = this.activateRoute.snapshot.paramMap.get('id');
        if (id !== 'nuevo' || !this.formGroup) {
            return;
        }

        const prefetchedName = String(this.activateRoute.snapshot.queryParamMap.get('nombre') || '').trim();
        const prefetchedPhone = this.resolvePrefilledPhone(this.activateRoute.snapshot.queryParamMap.get('celular'));
        const prefetchedCompanyId = Number(this.activateRoute.snapshot.queryParamMap.get('idEmpresa') || 0);

        this.formGroup.patchValue({
            nombre: prefetchedName || this.formGroup.get('nombre')?.value || '',
            celular: prefetchedPhone || this.formGroup.get('celular')?.value || '',
        });

        if (prefetchedCompanyId > 0) {
            this.formGroup.get('id_empresa')?.setValue(prefetchedCompanyId);
            await this.onEmpresa();
        }
    }

    private resolvePrefilledPhone(phone: string | null): string {
        const normalizedPhone = normalizeParaguayPhone(phone || '');
        if (normalizedPhone) {
            return normalizedPhone.replace('+595', '');
        }

        const digits = String(phone || '').replace(/\D+/g, '');
        if (!digits) {
            return '';
        }

        if (digits.startsWith('595')) {
            return digits.slice(3).replace(/^0+/, '');
        }

        return digits.replace(/^0+/, '');
    }

}
